import { gsap } from 'gsap';

// Градиент EC6328 → E4B064 → 65C5E6
const color12 = gsap.utils.interpolate("#EC6328", "#E4B064");
const color23 = gsap.utils.interpolate("#E4B064", "#65C5E6");

const getGradientColor = (progress) => {
  // первая половина: 0 → 0.5
  if (progress <= 0.5) {
    return color12(progress / 0.5);
  }
  // вторая половина: 0.5 → 1
  return color23((progress - 0.5) / 0.5);
};

const restartTitleAnimationIfNeeded = (item) => {
  if (!item.classList.contains('animated')) return;
  if (
    !item.classList.contains('title-animation') &&
    !item.classList.contains('title-animation-hero') &&
    !item.classList.contains('title-animation-soft')
  ) return;

  item.classList.remove('animated');

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      item.classList.add('animated');
    });
  });
};

const setTitleAnimationTiming = (item) => {
  const words = item.querySelectorAll('.word');
  const wordsCount = words.length || 1;

  if (item.classList.contains('title-animation-soft')) {
    let stagger = 48;
    let duration = 900;
    let blur = '8px';
    let offset = '12px';
    let startDelay = '90ms';

    if (wordsCount <= 5) {
      stagger = Math.max(68, Math.min(92, Math.round(360 / wordsCount)));
      duration = Math.max(1060, Math.min(1320, 1400 - wordsCount * 44));
      blur = '8px';
      offset = '14px';
      startDelay = '180ms';
    } else if (wordsCount <= 9) {
      stagger = Math.max(46, Math.min(64, Math.round(310 / wordsCount)));
      duration = Math.max(840, Math.min(1040, 1120 - wordsCount * 28));
      blur = '7px';
      offset = '11px';
      startDelay = '110ms';
    } else {
      stagger = Math.max(26, Math.min(36, Math.round(220 / wordsCount)));
      duration = Math.max(700, Math.min(840, 900 - wordsCount * 12));
      blur = '6px';
      offset = '9px';
      startDelay = '75ms';
    }

    item.style.setProperty('--title-soft-stagger', `${stagger}ms`);
    item.style.setProperty('--title-soft-duration', `${duration}ms`);
    item.style.setProperty('--title-soft-blur', blur);
    item.style.setProperty('--title-soft-y', offset);
    item.style.setProperty('--title-soft-start-delay', startDelay);
  }
};

if (document.querySelector('[data-splitting-title]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-title]');
  splittingArr.forEach((item) => {
    Splitting({
      target: item,
      by: 'words',
    });

    setTitleAnimationTiming(item);
    restartTitleAnimationIfNeeded(item);
  });
}

if (document.querySelector('[data-splitting-words]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-words]');
  splittingArr.forEach((item) => {
    Splitting({
      target: item,
      by: 'words',
    });
  });
}

if (document.querySelector('[data-splitting-chars]')) {
  const targets = document.querySelectorAll('[data-splitting-chars]');

  targets.forEach((item) => {
    Splitting({
      target: item,
      by: 'chars',
    });

    restartTitleAnimationIfNeeded(item);

    if (item.classList.contains('cl-gradient-js')) {
      const chars = item.querySelectorAll('.char');
      const total = chars.length - 1;

      gsap.set(chars, {
        color: (index) => getGradientColor(index / total),
      });

      item.classList.add('is-init-cl-gradient-js');

      return;
    }

    const innerGradientBlocks = item.querySelectorAll('.cl-gradient-js');

    if (innerGradientBlocks.length > 0) {
      innerGradientBlocks.forEach((block) => {
        const blockChars = block.querySelectorAll('.char');
        const total = blockChars.length - 1;

        gsap.set(blockChars, {
          color: (index) => getGradientColor(index / total),
        });

        block.classList.add('is-init-cl-gradient-js');
      });
    }
  });
}

/*if (document.querySelector('[data-splitting-chars]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-chars]');
  splittingArr.forEach((item) => {
    Splitting({
      target: item,
      by: 'chars',
    });
  });
  gsap.set(splitText.chars, {
    color: (index, target, targets) => color(index / (targets.length - 1))
  });
}*/

/*const variableFontAnimationElsArr = document.querySelectorAll('[data-variable-font-animation]');
variableFontAnimationElsArr.forEach((variableFontAnimationEl) => {
  const timeline = gsap.timeline({repeat: -1});
  const chars = variableFontAnimationEl.querySelectorAll(".char");

  // gsap.set(".one", {color: "#3498DB"});
  // gsap.set(".two", {color: "#E74C3C"});
  // gsap.set(".three", {color: "#F1C40F"});
  // gsap.set(".four", {color: "#3498DB"});
  // gsap.set(".five", {color: "#27AE60"});
  // gsap.set(".six", {color: "#E74C3C"});

  timeline.from(chars, {opacity: 0, scale: 0, ease: "sine", delay: 0.25})
      .to(".char", {
        opacity: 1,
        "--font-weight": 700,
        duration: 1.2,
        ease: "sine.inOut",
        stagger: {
          yoyo: true,
          each: 0.1,
          repeat: -1
        }
      }, 1);
})*/

